import TaskaShkspr from 'assets/img/taska-shkspr.svg'
import classNames from 'classnames'
import { PriceTypeItem, SplBestSeatTabs } from 'components'
import messages from 'i18n/messages'
import flowRight from 'lodash/flowRight'
import sortBy from 'lodash/sortBy'
import filter from 'lodash/filter'
import find from 'lodash/find'
import values from 'lodash/values'
import {
  fetchOffers,
  makeSelectControlsEnabled,
  makeSelectErr as makeSelectOrderErr,
  makeSelectPriceName,
  makeSelectQty,
  makeSelectTresholds,
  setPriceName,
  setQty,
  setBookingType,
  makeSelectBookingType,
} from 'logic/orders'
import { makeSelectPrices } from 'logic/pcts'
import Link from 'next/link'
import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'
import { connect } from 'react-redux'
import { Button, FormGroup, Input, Label } from 'reactstrap'
import { bindActionCreators } from 'redux'
import { createStructuredSelector } from 'reselect'
import { resOnly, saleOnly } from 'lib/misc'

const EventLocked = ({ org }) => (
  <div className="feedback-check">
    <img className="hero-img" src={TaskaShkspr} alt="" />
    <div className="m-4">
      <h3><FormattedMessage {...messages.eventLocked } /></h3>
      <Link href={`/${org.odn}`}>
        <Button color="primary">
          {org.name} - <FormattedMessage {...messages.overview} />
        </Button>
      </Link>
    </div>
  </div>
)

class TicketSettingsForm extends Component {

  state = {
    showPriceOptions: false,
    rowOrTable: '',
  }

  getSetQtyHandler = increase =>
    () => this.props.controlsEnabled && this.props.actions.setQty(increase ? this.props.qty + 1 : this.props.qty - 1)

  handleTogglePriceOptions = () => this.setState({ showPriceOptions: !this.state.showPriceOptions })

  componentDidUpdate (prevProps) {
    if (values(this.props.prices).length < 2 || this.props.prices === prevProps.prices) return
  
    this.setState({ showPriceOptions: true })
  }

  handleSelectBuy = () => this.props.actions.setBookingType('buy')

  handleSelectRes = () => this.props.actions.setBookingType('res')

  handleChangeRowOrTable = ({ target }) =>
    this.setState({ rowOrTable: target.getAttribute('value') }, () =>
      this.props.actions.fetchOffers(this.props.date.id, this.state.rowOrTable)
    )

  filterAndSortPrices = (prices, bookingType) => {
    const filterBo = find(prices, 'bo_only')
    const filtered = filterBo
        ? filter(prices, p => bookingType === 'res' ? p.bo_only : !p.bo_only)
        : prices
    return sortBy(values(filtered), 'position', 'created_at')
  }

  render() {
    const { qty, tresholds: { min, max }, bookingType, prices, controlsEnabled, date, org, orderErr } = this.props
    if (orderErr && orderErr === 'event-locked')
      return <EventLocked org={org} />

    return (
      <div className="tt-book-settings tickets-selection">
        { date.spl_enabled && !date.spl_view_disabled
          ? <SplBestSeatTabs date={date} org={org} />
          : null
        }
        {date.bestplace_booking_distinguish_sections
          ?
          <div className="select-seats">
            <Label>
              <FormattedMessage {...messages.selectRowOrTable} />
            </Label>
            <div className="select-row-or-table">
              <FormGroup check className="form-check-radio">
                <Label check>
                  <Input
                    type="radio"
                    name="row_or_table"
                    value="Reihen"
                    checked={this.state.rowOrTable === 'Reihen'}
                    onChange={this.handleChangeRowOrTable}
                  />
                  <span className="form-check-sign" />
                  <FormattedMessage {...messages.row} />
                </Label>
              </FormGroup>
              <FormGroup check className="form-check-radio">
                <Label check>
                  <Input
                    type="radio"
                    name="row_or_table"
                    value="Tische"
                    checked={this.state.rowOrTable === 'Tische'}
                    onChange={this.handleChangeRowOrTable}
                  />
                  <span className="form-check-sign" />
                  <FormattedMessage {...messages.table} />
                </Label>
              </FormGroup>
              <FormGroup check className="form-check-radio">
                <Label check>
                  <Input
                    type="radio"
                    name="row_or_table"
                    value=""
                    checked={this.state.rowOrTable === ''}
                    onChange={this.handleChangeRowOrTable}
                  />
                  <span className="form-check-sign" />
                  <FormattedMessage {...messages.both} />
                </Label>
              </FormGroup>
            </div>
          </div>
          : null
        }
        { date.sale_enabled && date.res_enabled && !resOnly() && !saleOnly()
          ? <div className="qty-form-control with-flex">
              <Label className="big-label">
                <FormattedMessage {...messages.pleaseSelect} />
              </Label>
              <div className="res-or-buy">
              <Button color={bookingType === 'buy' ? 'primary' : 'default'} outline={bookingType !== 'buy'} onClick={this.handleSelectBuy}>
                  <FormattedMessage {...messages.buy} />
                </Button>
                <FormattedMessage {...messages.or} />
                <Button color={bookingType === 'res' ? 'primary' : 'default'} outline={bookingType !== 'res'} onClick={this.handleSelectRes}>
                  <FormattedMessage {...messages.reserve} />
                </Button>
              </div>
            </div>
          : null
        }
        {date.less_than_book_max_qty_available
          ? <div className="type-form-control mb-2">
              <div className="desc text-primary text-center" style={{ width: '100%' }}>
                <FormattedMessage {...messages.onlyFewTicketsLeft} />
              </div>
            </div>
          : null
        }
        {prices && values(prices).length > 1
          ? <>
              <div className="type-form-control" onClick={this.handleTogglePriceOptions}>
                <Label>
                  <FormattedMessage {...messages.ticketType} />
                </Label>
                <div className="cur-form-selection">
                  <div className="cur-price-name"></div>
                  <span className={`toggle-prices tt-icon tt-icon-${this.state.showPriceOptions ? 'up' : 'down'}-arrow`} />
                </div>
              </div>
              <div className={classNames('qty-form-control-price-options', { open: this.state.showPriceOptions })}>
                {prices && this.filterAndSortPrices(prices, bookingType).map(price => <PriceTypeItem price={price} key={price.id} />)}
              </div>
            </>
          : <div className="qty-form-control with-flex">
              <Label className="big-label">
                <FormattedMessage {...messages.howManyTickets} />
              </Label>
              <div className="qty-switches">
                <div className={classNames('qty-btn', { disabled: (!controlsEnabled || qty <= min) })} onClick={this.getSetQtyHandler(false)}>
                  <span className="tt-icon tt-icon-i-delete" />
                </div>
                <div className="qty-value">
                  {qty}
                </div>
                <div className={classNames('qty-btn', { disabled: (!controlsEnabled || qty >= max) })} onClick={this.getSetQtyHandler(true)}>
                  <span className="tt-icon tt-icon-i-add" />
                </div>
              </div>
            </div>
        }
      </div>
    )
  }
}

const mapStateToProps = createStructuredSelector({
  qty: makeSelectQty(),
  tresholds: makeSelectTresholds(),
  controlsEnabled: makeSelectControlsEnabled(),
  priceName: makeSelectPriceName(),
  prices: makeSelectPrices(),
  bookingType: makeSelectBookingType(),
  orderErr: makeSelectOrderErr(),
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    setQty,
    setPriceName,
    setBookingType,
    fetchOffers,
  }, dispatch)
});

const enhance = flowRight(
  connect(mapStateToProps, mapDispatchToProps),
)

export default enhance(TicketSettingsForm)
